/* global window */
import axios from 'axios';
import translations from '../translations';

export const BASE_URL = process.env.REACT_APP_API_URL;

const getToken = () => {
  return window.localStorage.getItem('jwt.token');
};

export const setToken = (newToken) => {
  window.localStorage.setItem('jwt.token', newToken);
};

export const removeToken = () => {
  window.localStorage.removeItem('jwt.token');
};

const abstractRequest = (endpoint, { headers = {}, body, ...otherOptions }, method) => {
  return axios(`${BASE_URL}${endpoint}`, {
    ...otherOptions,
    headers: {
      ...headers,
      Authorization: `Bearer ${getToken()}`,
      Accept: 'application/json',
      'Accept-Language': translations.active,
      'Content-Type': 'application/json',
    },
    data: body ? JSON.stringify(body) : undefined,
    method,
  });
};

const checkForRefreshToken = (endpoint, content, method) => (error) => {
  if (error.response && error.response.status === 401 && getToken()) {
    return abstractRequest('/auth/refresh', {}, 'post').then(({ data }) => {
      setToken(data.access_token);

      return abstractRequest(endpoint, content, method);
    });
  }

  return Promise.reject(error);
};

const checkForRelogin = error => {
  if(error && error.response && error.response.status === 401) {
    const hadToken = getToken() !== null;

    // If there was a token, but an invalid one we will reload to the root.
    // We remove the token, because we have already tried to refresh it.
    // Otherwise this means there was no token, so we are probably on the login page.
    if(hadToken) {
      removeToken();

      window.location.href = '/';
    }
  }

  return Promise.reject(error.response);
};

const request = (endpoint, content, method) => {
  return abstractRequest(endpoint, content, method)
    .catch(checkForRefreshToken(endpoint, content, method))
    .catch(checkForRelogin);
};

export const api = {
  get(endpoint, options = {}) {
    return request(endpoint, options, 'get');
  },
  post(endpoint, options = {}) {
    return request(endpoint, options, 'post');
  },
  put(endpoint, options = {}) {
    return request(endpoint, options, 'put');
  },
};

export default api;